/* Populated by react-webpack-redux:action */
export const UPDATE_CHANNEL = 'UPDATE_CHANNEL';



// WEBPACK FOOTER //
// ./src/actions/const.js